import {viewModelLink} from "@/class/view-model";
import {volets} from "@/class/volets";
import {link} from "@/class/link";
import {Media, PK} from "@/class/data-type";
import store from "@/store/store";

export class video extends viewModelLink {
    
    objectType = "video";
    
    _pk = new PK("id")
    
    data = [
        {name: "name", type: String, default: "A renseigner"},
        {name: "video", type: Media, default: new Media({type:"video"})},
        {name: "poster", type: Media, default: new Media({type:"picture"})},
        {name: "orientation", type: String, default: "horizontal"},
        {name: "fit", type: String, default: "cover"},
        {name: "muted", type: Boolean, default: false},
        {name: "autostart", type: Boolean, default: false},
        {name: "subtitles", type: Media, default: new Media({type:"text"})},
        {name: "show_controls", type: Boolean, default: false},
        {name: "end_action", type: String, default: "none"},
        {name: "subtype", type: String, default: "standard"},
    ]
    
    volets = new volets().set([
        {label: "Video", component: "Video_Data"},
        {label: "Settings", component: "Video_Settings"},
    ]);
    
    link = new link();
    
    constructor() {
        super();
        this.init();
    }
    
    getThumbnail(){
        return this.poster.media || store.getters.getDefault("BaseImage");
    }
    
    setDataReq(data) {
        super.setDataReq(data);
        if(data["end_action"]) {
            this.link.load(data)
        }
    }
}